import React from "react";
import axios from "axios";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import Divider from "@material-ui/core/Divider";
import Button from "@material-ui/core/Button";
import { FiX } from "react-icons/fi";

import logo from "../../logo.png";
import { useAxiosPost, api } from "../../Services/Api";
import { getMessagingToken } from "../../Services/Firebase";
import { Container, Cover, Form, Input, Title, Brand, New } from "./style";
import { SignInError as LoginError } from "../../Theme";
import Loading from "../../Components/Loading";

export default function Login() {
  const [{ data, loading, error }, login] = useAxiosPost("auth/login");
  const [openChangePassword, setOpenChangePassword] = React.useState(false);
  const [sendingRequestChangePassword, setSendingRequestChangePassword] =
    React.useState(false);

  const handleSubmit = (data) => {
    login(data);
  };

  React.useEffect(() => {
    // window.zE("webWidget", "hide");
  }, []);

  if (data) {
    localStorage.setItem("token", data.accessToken);
    getMessagingToken()
      .then((token) => {
        api
          .patch(`/notifications/push/activate-client?clientId=${token}`)
          .then(() => {
            window.location = "/";
          })
          .catch((err) => {
            api
              .post("/notifications/push", { clientId: token })
              .catch((err) => console.log(err))
              .finally(() => {
                window.location = "/";
              });
          });
      })
      .catch((err) => {
        console.log("As notificações estão desabilitadas");
        window.location = "/";
      });
  }

  if (error) console.log(error);

  function handleClose() {
    setOpenChangePassword(false);
  }

  function handleChangePassword({ email }) {
    setSendingRequestChangePassword(true);
    axios
      .post(
        `${process.env.REACT_APP_API_URL}/auth/forgot-password?email=${email}`
      )
      .then(({ data }) => {
        setOpenChangePassword(false);
        alert("Falta pouco! Já te enviamos o email de redefinição de senha!");
      })
      .catch((err) => {
        alert("Não foi possível enviar a solicitação nesse momento!");
      })
      .finally(() => {
        setSendingRequestChangePassword(false);
      });
  }

  return (
    <Container>
      <Cover />
      <Form onSubmit={handleSubmit}>
        <Brand>
          <img src={logo} />
        </Brand>
        <Title>Entrar</Title>
        <Input required type="email" placeholder="Email" name="email" />
        <Input required type="password" placeholder="Senha" name="password" />
        {error && (
          <LoginError>
            Email ou senha incorretos. <br /> Tente novamente, por favor{" "}
          </LoginError>
        )}
        <button>Continuar</button>
        <a
          style={{
            textDecoration: "underline",
            color: "#007bff",
            cursor: "pointer",
          }}
          onClick={() => setOpenChangePassword(true)}
        >
          Esqueceu a senha?
        </a>
        {(loading || data) && <Loading />}
        <Divider />
        <New>
          <p>
            Novo por aqui?{" "}
            <a href="https://portal.mindi.com.br/#/sign-in">Cadastre-se</a>
          </p>
        </New>
      </Form>

      <Dialog
        fullWidth
        maxWidth="xs"
        open={openChangePassword}
        onClose={handleClose}
      >
        <DialogTitle>
          <Button
            style={{ position: "absolute", right: "10px", top: "10px" }}
            onClick={handleClose}
          >
            <FiX style={{ fontSize: "25px" }} />
          </Button>
        </DialogTitle>
        <DialogContent>
          <Form
            onSubmit={handleChangePassword}
            style={{ width: "100%", padding: "0px" }}
          >
            <div>
              Digite o seu e-mail para enviarmos um link de redefinição de senha
            </div>
            <Input required type="email" placeholder="Seu Email" name="email" />
            <button>Redefinir Senha</button>
            {sendingRequestChangePassword && <Loading />}
          </Form>
        </DialogContent>
      </Dialog>
    </Container>
  );
}
